import { MatchesH2HData } from "@/interfaces/liveGamesType";
import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const fetchH2H = (
  team1Id: string,
  team2Id: string,
  options?: Partial<UseQueryOptions<MatchesH2HData>>
) => {
  const response = useQuery({
    queryKey: ["football/getH2H", team1Id, team2Id],
    queryFn: async () => {
      const res = await api.get(`/football/getH2H`, {
        params: {
          firstTeamId: team1Id,
          secondTeamId: team2Id,
        },
      });

      return res.data;
    },
    ...options,
  });

  return response;
};
